import { dialogClasses } from '@mildang/mui';
import Dialog, { NormalDialogProps } from '../Dialog';
import { css as emotionCSS } from '@emotion/react';
import ConfirmDialogContent, { ConfirmDialogContentProps } from './ConfirmDialogContent';
import { Theme } from '@mildang/mui';

const dialogStyle = (theme: Theme) => emotionCSS`
  z-index: ${theme.zIndex.snackbar};
  .${dialogClasses.paperWidthXs} {
    max-width: 312px;
    min-height: auto;
  }
`;

export interface ConfirmDialogProps
  extends Pick<
    ConfirmDialogContentProps,
    'title' | 'description' | 'dismissButtonProps' | 'confirmButtonProps' | 'color'
  > {
  DialogProps: NormalDialogProps;
}

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { DialogProps, ...ConfirmDialogContentProps } = props;

  return (
    <Dialog maxWidth="xs" css={dialogStyle} {...DialogProps}>
      <ConfirmDialogContent {...ConfirmDialogContentProps} />
    </Dialog>
  );
};

export default ConfirmDialog;
